<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-13 16:50:15
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterTemplate\editRosterTemplate.vue
 -->
<template>
  <ContentLayout
    pad="0"
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_RosterTemplate_form_editTitle')
        : $t('label_essweb_RosterTemplate_form_viewTitle')
    "
    delBtn
    :initData="RosterTemplateData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'roster_weekly_template_name',
      'std_work_integer',
      'roster_weekly_template_code',
      'std_work_text',
      'start_utc_datetime',
      'roster_weekly_template_description',
      'is_default',
      'remarks',
    ]"
    :editBtn="!iSEdited"
    backgroundClass="white"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_RosterTemplate_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :bindData="RosterTemplateData.roster_weekly_template_name"
                  @change="
                    (valueArr) => {
                      RosterTemplateData.roster_weekly_template_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterTemplate_form_rosterTemplateNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="RosterTemplateData.roster_weekly_template_code"
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  maxlength="500"
                  :bindData="
                    RosterTemplateData.roster_weekly_template_description
                  "
                  @change="
                    (valueArr) => {
                      RosterTemplateData.roster_weekly_template_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterTemplate_form_rosterTemplateDescriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <DateTimePicker
                  type="date"
                  placeholder="YYYY/MM/DD"
                  :filled="iSEdited"
                  :label="
                    $t('label_essweb_RosterFormRecord_list_startDateLabel')
                  "
                  :defaultTime="RosterTemplateData.start_utc_datetime"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  @change="
                    (time) => {
                      RosterTemplateData.start_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <normalInputTextFiled
                  type="number"
                  maxlength="11"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  v-model="RosterTemplateData.std_work_integer"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  :label="
                    $t('label_essweb_RosterTemplate_form_stdWorkMinutesLabel')
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <normalInputTextFiled
                  maxlength="100"
                  :filled="iSEdited"
                  readonly
                  v-model="RosterTemplateData.std_work_text"
                  :label="
                    $t('label_essweb_RosterTemplate_form_stdWorkTimeLabel')
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_RosterTemplate_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  dense
                  counter="500"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  v-model="RosterTemplateData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12" class="ml-3">
                <v-checkbox
                  v-model="RosterTemplateData.is_default"
                  :label="$t('label_essweb_RosterTemplate_form_setAsDefault')"
                  color="primary"
                  :disabled="!iSEdited"
                  required
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts"
            :avPerPage="20"
            :showFooter="false"
          >
            <template v-slot:top>
              <div class="mx-auto">
                <v-form ref="form2" lazy-validation>
                  <v-row dense>
                    <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                      <v-sheet class="mrc_text_require text--secondary">{{
                        $t("label_essweb_RosterTemplate_form_cycleTypeLabel")
                      }}</v-sheet>
                      <v-select
                        :items="CycleTypeList"
                        dense
                        filled
                        disabled
                        item-value="value_field"
                        item-text="view_fields"
                        hide-details
                        :menu-props="{
                          offsetY: true,
                          transition: 'slide-y-transition',
                          rounded: true,
                          contentClass: 'elevation-4',
                        }"
                        :placeholder="
                          $t('label_essweb_RosterTemplate_form_cycleTypeLabel')
                        "
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        v-model="curCycleType"
                        single-line
                      >
                        <template v-slot:no-data> <noContent /> </template>
                        <template v-slot:selection="data">
                          {{ $getCommonLangValue(data.item.view_fields) }}
                        </template>
                        <template v-slot:item="data">
                          {{ $getCommonLangValue(data.item.view_fields) }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </template>
            <template v-slot:item.sequence="{ item }">
              <div class="table-title text--primary">
                {{
                  curCycleType
                    ? $getCommonLangValue(
                        curWeek[Number(item.sequence)].view_fields
                      )
                    : item.sequence
                }}
              </div>
            </template>
            <template v-slot:item.name="{ item }">
              <div
                class="table-title text--primary"
                :title="
                  item.shift
                    ? $getCommonLangValue(item.shift.shift_name) +
                      '(' +
                      $timeMachine(item.shift.start_utc_time) +
                      ' - ' +
                      $timeMachine(item.shift.end_utc_time) +
                      ')'
                    : ''
                "
              >
                {{
                  item.shift
                    ? $getCommonLangValue(item.shift.shift_name) +
                      "(" +
                      $timeMachine(item.shift.start_utc_time) +
                      " - " +
                      $timeMachine(item.shift.end_utc_time) +
                      ")"
                    : ""
                }}
              </div>
            </template>
            <!-- action -->
            <template v-slot:item.action="{ item }">
              <v-btn :disabled="!iSEdited" icon @click="toEditProperty(item)">
                <span class="material-icons-round">edit</span>
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>

    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <editRosterTemplateDialog
        :show="showEditDialog"
        :curProperty="curProperty"
        @onEdit="onEditProperty"
        @close="showEditDialog = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import editRosterTemplateDialog from "@/Page/EssAdmin/Roster/RosterTemplate/components/editRosterTemplateDialog";
import { mapGetters } from "vuex";
export default {
  name: "editPublicHolidayGroup",
  components: { editRosterTemplateDialog },
  computed: {
    ...mapGetters(["companyLang"]),
    curWeek() {
      if (this.curCycleType == 7) return this.single_week;
      if (this.curCycleType == 14) return this.double_week;
    },
    curObject() {
      const that = this;
      var arr = [];
      that.canApproval = true;
      this.desserts.map(function (item) {
        if (item.shift) {
          arr.push({
            uuid: item.uuid,
            sequence: item.sequence,
            roster_template_uuid: that.$route.params.id,
            shift_uuid: item.shift.uuid,
            remarks: item.remarks,
          });
        } else {
          that.canApproval = false;
          arr.push(null);
        }
      });
      return arr;
    },
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      canApproval: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_RosterTemplate_form_step_generalLabel",
        "label_essweb_RosterTemplate_form_step_Mapping",
      ],
      showEditDialog: false,
      mapToDiag: false,
      curProperty: null,
      curAction: "new",
      page: 1,
      CycleTypeList: [],
      curCycleType: 7,
      RosterTemplateData: {
        roster_weekly_template_name: "",
        roster_weekly_template_code: "",
        roster_weekly_template_description: "",
        roster_type: "",
        std_work_integer: 0,
        start_utc_datetime: "",
        std_work_text: "00:00",
        sequence: null,
        is_default: false,
        remarks: "",
      },
      desserts: [],
      curUuids: [],
      headers: [
        {
          text: "label_essweb_RosterTemplate_form_list_sequenceLabel",
          value: "sequence",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_rosterForm_form_list_shiftTimeLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    "RosterTemplateData.std_work_integer": function (val) {
      if (val) {
        if (val.toString().length > 1 && val.toString()[0] == "0") {
          this.RosterTemplateData.std_work_integer = val
            .toString()
            .substring(1, val.toString().length);
        }
      }
      if (Number(val) > 0) {
        this.RosterTemplateData.std_work_text = this.$timeMachine(Number(val));
      } else {
        this.RosterTemplateData.std_work_text = "00:00";
      }
    },
  },
  mounted() {
    const that = this;
    // 获取单周
    this.$findPrompt({
      prompt_name: "ess_single_week_roster_template_shift_sequence_select",
    }).then((res) => {
      that.single_week = res.data;
    });
    // 获取双周
    this.$findPrompt({
      prompt_name: "ess_biweekly_roster_template_shift_sequence_select",
    }).then((res) => {
      that.double_week = res.data;
    });
    // 获取cycleType
    this.$findPrompt({
      prompt_name: "ess_roster_template_period_type_select",
    }).then((res) => {
      res.data.map((item) => {
        item["value_field"] = Number(item["value_field"]);
      });
      that.CycleTypeList = res.data;
    });
    this.getDetail();
    this.getPorpertyList();
  },
  methods: {
    onEditProperty: function (obj) {
      const that = this;
      this.showEditDialog = false;
      // this.$Request({
      //   method: "POST",
      //   table: "ess_att_map_roster_template_shift",
      //   url: "/roster-template-map/update/",
      //   data: {
      //
      //     uuid: this.$route.params.id,
      //     shift_uuid: obj.shift.uuid,
      //   },
      // }).then((res) => {
      that.desserts.some(function (item, index) {
        if (item.uuid == obj.uuid) {
          that.desserts.splice(index, 1, {
            uuid: obj.uuid,
            sequence: obj.sequence,
            shift: obj.shift,
            remarks: obj.remarks,
          });
        }
      });
      // });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["roster_weekly_template_name_save"] =
          res.data.roster_weekly_template_name;
        res.data.roster_weekly_template_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.roster_weekly_template_name
        );
        res.data["roster_weekly_template_description_save"] =
          res.data.roster_weekly_template_description;
        res.data.roster_weekly_template_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.roster_weekly_template_description
          );
        res.data.start_utc_datetime = this.$getDateTime(
          res.data.start_utc_datetime,
          "YYYY-MM-DD"
        );
        that.RosterTemplateData.roster_type = Number(res.data.roster_type);
        that.curCycleType = that.RosterTemplateData.roster_type;
        that.RosterTemplateData.is_default = Number(res.data.is_default)
          ? true
          : false;
        that.RosterTemplateData = res.data;
      });
    },
    toNewMapping: function () {
      const that = this;
      this.curAction = "edit";
      this.curPorperty = [];
      //
      this.mapToDiag = true;
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template-map/get-list/",
        data: {
          roster_template_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.map((item, index) => {
          that.desserts.push({
            uuid: item.uuid,
            sequence: item.sequence,
            shift: {
              uuid: item.shift_uuid,
              shift_name: item.shift_name,
              shift_description: item.shift_description,
              shift_type_uuid: item.shift_type_uuid,
              start_utc_time: item.start_utc_time,
              start_time_time_zone: item.start_time_time_zone,
              end_utc_time: item.end_utc_time,
              end_time_time_zone: item.end_time_time_zone,
              total_working_minutes: item.total_working_minutes,
              color_code: item.color_code,
              effective_utc_start_date: item.effective_utc_start_date,
              effective_start_time_zone: item.effective_start_time_zone,
              effective_utc_end_date: item.effective_utc_end_date,
              effective_end_time_zone: item.effective_end_time_zone,
              shift_property_group_uuid: item.shift_property_group_uuid,
            },
            remarks: item.remarks,
          });
        });
      });
    },
    toBack: function () {
      // if (this.iSEdited) {
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },

    toEditProperty: function (item) {
      const that = this;
      setTimeout(function () {
        that.curProperty = {
          uuid: item.uuid,
          sequence: item.sequence,
          shift: item.shift,
          remarks: item.remarks,
        };
      }, 300);
      that.showEditDialog = true;
    },
    toSave: function () {
      const that = this;
      if (this.curTab == "tab-1") {
        if (!this.$refs["form"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
        this.$Request({
          method: "POST",
          table: "ess_att_roster_weekly_template",
          url: "/roster-template/update/",
          data: {
            uuid: this.$route.params.id,
            roster_weekly_template_name: this.$transCommonLangKey(
              this.RosterTemplateData.roster_weekly_template_name,
              this.RosterTemplateData.roster_weekly_template_name_save
            ),
            roster_weekly_template_code:
              this.RosterTemplateData.roster_weekly_template_code,
            std_work_integer: this.RosterTemplateData.std_work_integer,
            std_work_text: this.RosterTemplateData.std_work_text,
            start_utc_datetime: this.$getTimeValue(
              this.RosterTemplateData.start_utc_datetime
            ),
            roster_weekly_template_description: this.$transCommonLangKey(
              this.RosterTemplateData.roster_weekly_template_description,
              this.RosterTemplateData.roster_weekly_template_description_save
            ),
            is_default: this.RosterTemplateData.is_default ? 1 : 0,
            remarks: this.RosterTemplateData.remarks,
          },
        }).then((res) => {
          that.toBack();
          that.$showMessage({
            text: that.$t(
              "message_essweb_RosterTemplate_list_updateRosterTemplateSuccessLabel"
            ),
            type: "success",
          });
        });
      } else {
        that.toSaveType();
      }
    },
    toSaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/update/",
        data: {
          uuid: this.$route.params.id,
          ess_att_map_roster_template_shift: this.curObject,
        },
      }).then((res) => {
        that.toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterTemplate_list_updateRosterTemplateConfigSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterTemplate_list_deleteRosterTemplateSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
